//#endregion
//#region src/index.ts
var e = {
	messages: {
		en: { menuTree: {
			menuTreeLabel: "Menu tree",
			common: {
				brand: "Brand",
				menuType: "Menu type",
				rootHeader: "Header root",
				rootSidebar: "Sidebar root"
			},
			list: {
				search: "Search by Type or Brand",
				brandFilter: "Filter by brand",
				menuTypeFilter: "Filter by menu type",
				brand: "Brand",
				menuType: "Menu type",
				menuTypeHeader: "Header",
				menuTypeSidebar: "Sidebar",
				createDate: "Creation date",
				changeDate: "Changed at",
				edit: "Edit",
				createMenu: "Create menu section",
				createMenuHint: "Only empty menu sections are shown.",
				createHeader: "Create header",
				createSidebar: "Create sidebar"
			},
			edit: {
				title: "Edit menu",
				menuSection: "Menu",
				addLink: "Link",
				addChild: "Add child item",
				addBelow: "Add item below",
				channelNotFound: "Channel path not found",
				deleteBlocked: "Cannot delete this node because it has children.",
				deleteConfirm: "Delete this menu item?"
			},
			item: {
				newTitle: "Edit menu item",
				editTitle: "Edit menu item",
				parent: "Parent",
				title: "Title",
				channelTitle: "Channel title",
				subtitle: "Subtitle",
				markAsAd: "Mark as AD",
				tag: "Tag",
				urlType: "URL Type",
				internalLink: "INTERNAL LINK",
				absoluteLink: "ABSOLUTE LINK",
				entry: "ENTRY",
				channelOrPage: "Channel or page",
				channelPath: "Channel path",
				url: "URL",
				delete: "Delete menu item",
				deleteConfirm: "Delete this menu item?",
				channelRequired: "Please select a channel.",
				invalidUrl: "Please enter a valid link (URL, relative path, or #anchor)."
			},
			api: { updated: "Menu tree updated" }
		} },
		de: { menuTree: {
			menuTreeLabel: "Menübaum",
			common: {
				brand: "Marke",
				menuType: "Menütyp",
				rootHeader: "Header Root",
				rootSidebar: "Sidebar Root"
			},
			list: {
				search: "Suche nach Typ oder Marke",
				brandFilter: "Nach Marke filtern",
				menuTypeFilter: "Nach Menütyp filtern",
				brand: "Marke",
				menuType: "Menütyp",
				menuTypeHeader: "Header",
				menuTypeSidebar: "Sidebar",
				createDate: "Erstellt am",
				changeDate: "Geändert am",
				edit: "Bearbeiten",
				createMenu: "Menübereich erstellen",
				createMenuHint: "Es werden nur leere Menübereiche angezeigt.",
				createHeader: "Header erstellen",
				createSidebar: "Sidebar erstellen"
			},
			edit: {
				title: "Menü bearbeiten",
				menuSection: "Menü",
				addLink: "Link",
				addChild: "Unterpunkt hinzufügen",
				addBelow: "Eintrag darunter hinzufügen",
				channelNotFound: "Channel-Pfad nicht gefunden",
				deleteBlocked: "Dieser Eintrag kann nicht gelöscht werden, weil er Unterpunkte hat.",
				deleteConfirm: "Diesen Menüpunkt löschen?"
			},
			item: {
				newTitle: "Menüpunkt bearbeiten",
				editTitle: "Menüpunkt bearbeiten",
				parent: "Parent",
				title: "Titel",
				channelTitle: "Channel-Titel",
				subtitle: "Untertitel",
				markAsAd: "Als AD markieren",
				tag: "Tag",
				urlType: "URL Typ",
				internalLink: "INTERNER LINK",
				absoluteLink: "ABSOLUTER LINK",
				entry: "ENTRY",
				channelOrPage: "Channel oder Seite",
				channelPath: "Channel-Pfad",
				url: "URL",
				delete: "Menüpunkt löschen",
				deleteConfirm: "Diesen Menüpunkt löschen?",
				channelRequired: "Bitte einen Channel auswählen.",
				invalidUrl: "Bitte einen gueltigen Link eingeben (URL, relativer Pfad oder #Anker)."
			},
			api: { updated: "Menübaum aktualisiert" }
		} }
	},
	routes: [{
		path: "/menu-tree",
		children: [{
			path: "",
			name: "menu_tree_list",
			component: () => import("./menu-tree-list.view-CR37ELkb.js"),
			meta: { requiredRight: "menu-tree:navigate" }
		}, {
			path: ":id/:menuType",
			component: () => import("./menu-tree-shell.view-ycAGDnUJ.js"),
			props: (e) => ({
				id: e.params.id,
				menuType: e.params.menuType
			}),
			children: [
				{
					path: "",
					name: "menu_tree_edit",
					component: () => import("./menu-tree-edit.view-DGllRUer.js"),
					props: (e) => ({
						id: e.params.id,
						menuType: e.params.menuType
					}),
					meta: { requiredRight: "menu-tree:navigate" }
				},
				{
					path: "item/new",
					name: "menu_tree_item_new",
					component: () => import("./menu-tree-item-edit.view-DdwEtlBS.js"),
					props: (e) => ({
						id: e.params.id,
						menuType: e.params.menuType
					}),
					meta: { requiredRight: "menu-tree:navigate" }
				},
				{
					path: "item/:path",
					name: "menu_tree_item_edit",
					component: () => import("./menu-tree-item-edit.view-DdwEtlBS.js"),
					props: (e) => ({
						id: e.params.id,
						menuType: e.params.menuType,
						path: e.params.path
					}),
					meta: { requiredRight: "menu-tree:navigate" }
				}
			],
			meta: { requiredRight: "menu-tree:navigate" }
		}]
	}],
	contentBlocks: []
};
//#endregion
export { e as menuTreeModule };

//# sourceMappingURL=index.es.js.map